import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "28",
  fill: "none",
  overflow: "visible"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D5D8DB",
      d: "M11.9 15.808V28H0v-9.625q0-7.816 1.973-11.317 2.59-4.666 8.2-7.058l2.713 4.083q-3.39 1.342-4.994 4.025-1.603 2.625-1.788 7.7zm19.114 0V28h-11.9v-9.625q0-7.816 1.973-11.317 2.59-4.666 8.2-7.058L32 4.083q-3.39 1.342-4.994 4.025-1.603 2.625-1.788 7.7z"
    }, null, -1)
  ]))]))
}
export default { render: render }